export default __webpack_public_path__ + "static/media/ladakpackage.7de5bb82.jpg";